import * as React from "react";
import Wait from "../wait";
import PopDetail from "../popdetail";
import {ProjectsService} from "../../service/v1/projects";
import PaneAddLocalityInfo from "../add/add_locality_info";
import CreateService from "../../service/create";

export default class LocalityInfoPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            required_localities:[],
            attached_localities:[]
        }
        this.loadData = this.loadData.bind(this)
        this.updateDocumentCounter = this.updateDocumentCounter.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    updateDocumentCounter(localityId,field, value){
        try {
            CreateService.updateDocumentCounter({
                locality_id: localityId,
                field: field,
                value: value,
                project_id: this.props.project.id
            }).then( r =>{ console.log(r.data)})
        }catch (e) {

        }
    }

    deleteSignatory(d){
        try {
            let signatoryId = d.id
            //TODO Delete Signatory by ID
        }catch (e) {
            console.log(e)
        }
    }

    render() {

        return (<div className={'row'}>




            <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-map'} style={{marginRight: '8px'}}/>
                        Localities
                    </span>

                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

             <div className={'row'}>
                <div className={'col col-sm-3'} style={{height: '80vh', padding: 0}}>

                    <div className={'col col-sm-12'}
                         style={{height: '50%', borderBottom: '1px solid #ccc', padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            <span className={'fa fa-paperclip'}/>Required Localities
                        </div>
                        <div style={{margin: '16px'}}>
                            {this.state.required_localities.map((d, i) => {
                                return (<div className={'sub-menu'} onClick={()=>PopDetail.show('Update Locality',
                            <PaneAddLocalityInfo loadData={this.loadData} taskId={this.props.taskId} screen_code={this.props.screen_code} locality={d} project={this.props.project} key={new Date().getMilliseconds()}/>,42)}
                                             key={i} style={{color:'darkcyan', float:'left',margin:0,width:'100%',padding:'4px'}}>
                                    <span className={'fa fa-times'}/>
                                    {d.name}
                                    <span className={'fa fa-plus'} style={{
                                                float: 'right',
                                                color: '#00984b',
                                                fontSize: '18px'
                                            }}/>
                                </div>)
                            })}

                        </div>
                    </div>

                    <div className={'col col-sm-12'}
                         style={{height: '50%', padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            <span className={'fa fa-paperclip'}/>Attached Localities
                        </div>

                        <div style={{margin: '16px'}}>
                            {this.state.attached_localities.map((d, i) => {
                                return (<div className={'sub-menu'}
                                             key={i} style={{color:'darkcyan',float:'left',margin:0,width:'100%',padding:'4px'}} title={d.description}>
                                    <span className={'fa fa-check'}/>

                                    <span onClick={() => PopDetail.show(d.name,<div> {d.name}</div>)}>
                                        {d.name}
                                    </span>
                                    <span className={'fa fa-trash'} onClick={() => this.deleteSignatory(d)}
                                          style={{float: 'right', color: '#f00', fontSize: '18px'}}/>
                                </div>)
                            })}
                        </div>
                    </div>


                </div>
                <div className={'col col-sm-9'} style={{height: '83vh',borderLeft: '1px solid #ccc'}}>
                    <br/>
                    <table className={'tb'} style={{width:'100%'}}>
                        <thead>
                        <tr>
                            <th>Locality Name</th>
                             <th>Total CCRO</th>
                            <th/>
                            <th/>
                        </tr>
                        </thead>
                        <tbody>

                        {this.state.data.map((d,i)=>{
                            return(<tr key={i} className={'tr'} style={{cursor:'pointer'}} >


                                <td style={{verticalAlign:'top'}}>
                                    <b style={{color:'darkcyan'}}>{d.name} </b>
                                </td>
                                <td style={{verticalAlign:'top'}}>
                                    <input defaultValue={d.count} style={{width:'96%'}} onChange={(e)=>this.updateDocumentCounter(d.id,'count',e.target.value)}/>
                                </td>
                                <td style={{verticalAlign:'top'}} colSpan={i>0?1:2}>
                                    <span className={'label'}>Registration Number</span><br/>
                                    <input type={'text'} defaultValue={d.registration_code} style={{width:'97%'}} onChange={(e)=>this.updateDocumentCounter(d.id,'code',e.target.value)}/><br/>
                                    <span className={'label'}>Address</span><br/>
                                    <input type={'text'} defaultValue={d.address} style={{width:'97%'}} onChange={(e)=>this.updateDocumentCounter(d.id,'address',e.target.value)}/><br/>
                                    <span className={'label'}>Meeting Date</span><br/>
                                    <input type={'date'} style={{width:'97%'}} defaultValue={d.meeting_date} onChange={(e)=>this.updateDocumentCounter(d.id,'date',e.target.value)}/><br/>
                                    <button className={'btn default'} style={{marginTop:'8px'}}>Update</button>
                                </td>
                                <td style={{display:i>0?'table-cell':'none'}}>
                                    <table className={'tb'} style={{width:'100%'}}>
                                        <thead>
                                        <tr>
                                            <th>Hamlet Name</th>
                                            {/*<th>Total CCRO</th>*/}
                                            <th>Hamlet Code</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {d.child.map((h,j)=>{
                                            return(<tr key={j}>
                                                <td>{h.name}</td>


                                               {/* <td style={{color:"darkcyan",fontWeight:"bold"}}>
                                                    <input defaultValue={h.count} onChange={(e)=>this.updateDocumentCounter(h.id,'count',e.target.value)} style={{width:'96%'}}/>
                                                </td>*/}

                                                <td>
                                                    <input key={j} defaultValue={h.registration_code} style={{width:'96%'}} onChange={(e)=>this.updateDocumentCounter(h.id,'code',e.target.value)} />
                                                </td>
                                            </tr>)
                                        })}
                                        </tbody>
                                    </table>
                                </td>
                            </tr>)
                        })}
                        </tbody>
                    </table>

                </div>


            </div>


        </div>)
    }


    loadData() {
        try {
            Wait.show('Fetching Signatories....')
            ProjectsService.fetchProjectLocalities(this.props.project.id).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.localites,
                    required_localities:r.data.required_localities,
                    attached_localities:r.data.attached_localities
                })
            })
        }catch (e) {
            Wait.dismiss()
        }
    }
}
